<template>
  <v-app class="text-font">
    <v-content>
      <installprompt/>
      <Navbar :key="$route.fullPath" />
      <router-view/>
    </v-content>
  </v-app>
</template>

<script>
import Navbar from './components/Navbar'
import InstallPrompt from './components/InstallPrompt'
export default {
  name: 'App',

  components: {
    Navbar,
    InstallPrompt
  },

  data: () => ({

  }),
};

</script>

<style>
  @font-face {
      font-family: 'Neo Sans Regular';
      src: url('./assets/font/NeoSansW1G-Regular.woff2') format('woff2'),
          url('./assets/font/NeoSansW1G-Regular.woff') format('woff'),
          url('./assets/font/NeoSansW1G-Regular.ttf') format('truetype');
      font-weight: normal;
      font-style: normal;
  }

  @font-face {
      font-family: 'Neo Sans Bold';
      src: url('./assets/font/NeoSansW1G-Bold.woff2') format('woff2'),
          url('./assets/font/NeoSansW1G-Bold.woff') format('woff'),
          url('./assets/font/NeoSansW1G-Bold.ttf') format('truetype');
      font-weight: bold;
      font-style: normal;
  }
.text-font {
  font-family: 'Neo Sans Regular',sans-serif!important;
}
.text-font-bold {
    font-family: 'Neo Sans Bold',sans-serif!important;
}
.title-font {
    font-size: 1.25rem !important;
    font-weight: 600;
    line-height: 2rem;
    letter-spacing: 0.0125em !important;
}
h1,h2,h3,p {
  color: #3C4448;
}
.subtitle-text {
    font-size: 1rem !important;
    font-weight: 100;
    letter-spacing: 0.009375em !important;
    line-height: 1.75rem;
}
.margin-center {
  margin: 0 auto!important;
}
</style>